import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import { withModel } from '../data-providers/model';

const withErrors = compose(
  withModel,
  withProps(props => ({
    errors: {
      ...props.model.prismicGlobalContentModel.error,
    },
  })),
);

export default withErrors;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withErrors.js